<div class="order-detail__header">
  Assinatura - Detalhes do pedido de {{ shippingOrderType }}
</div>
<div class="order-detail__content" *ngIf="shippingOrder && rewards">
  <div class="order-detail__content__left">
    <app-person-card
      *ngIf="person"
      [person]="person"
      [influencer]="influencer"
      [showProfileLink]="person?.personId > 0"
      [showResetPassword]="person?.personId > 0"
    />
  </div>
  <div class="order-detail__content__right">
    <div class="card shipping-order">
      <span class="info">
        <strong>Tipo:</strong>&nbsp;
        <span>{{ shippingOrderType | titlecase }}</span>
      </span>
      <span class="info">
        <strong>ID</strong>:
        <span>{{ shippingOrder.shippingOrderId }}</span>
      </span>
      <span class="info">
        <strong>Data do pedido</strong>:
        {{ shippingOrder.dateCreated | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info" *ngIf="shippingOrder?.shippingOrderTypeId === 4">
        <strong>Motivo do brinde</strong>:
        {{ referenceName }}
      </span>
      <span class="info">
        <strong>Status</strong>:&nbsp;
        <span class="status" [ngClass]="shippingOrderStatusClass">
          {{ shippingOrderStatus | titlecase }}
        </span>
      </span>
      <span class="info">
        <strong>Data exportação</strong>:
        <ng-container *ngIf="shippingOrder.dateSyncERP">
          {{ shippingOrder.dateSyncERP | date: 'dd/MM/yyyy HH:mm:ss' }}
        </ng-container>
        <ng-container *ngIf="!shippingOrder.dateSyncERP">
          Não exportado
        </ng-container>
      </span>
      <span class="info">
        <strong>Status Millennium</strong>:&nbsp;
        <span class="status" [ngClass]="millenniumStatusClass">
          {{ millenniumStatus | titlecase }}
        </span>
      </span>
      <span class="info">
        <strong>Pedido V</strong>:
        {{ order?.pedidoV || 'Não informado' }}
      </span>
      <span class="info">
        <strong>Nº da nota:</strong>:
        {{
          edition?.invoiceNumber ||
            shippingOrder?.invoiceNumber ||
            'Não informado'
        }}
        <ng-container
          *ngIf="
            edition?.pedidoV ||
            edition?.invoiceNumber ||
            order?.pedidoV ||
            shippingOrder?.invoiceNumber
          "
        >
          &nbsp;
          <p-button
            size="small"
            styleClass="p-button-xs"
            severity="primary"
            icon="pi pi-truck"
            [rounded]="true"
            (onClick)="openTrackingModal()"
            pTooltip="Ver rastreio"
          />
        </ng-container>
      </span>
      <span class="info">
        <strong>Chave NFE:</strong>:
        {{ shippingOrder.nfse || edition?.chaveNFE || 'Não informado' }}
      </span>
      <span class="info">
        <strong>Últ. Atualização Millennium</strong>:
        <ng-container *ngIf="lastDateUpdatedMillennium">
          {{ lastDateUpdatedMillennium | date: 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        <ng-container *ngIf="!lastDateUpdatedMillennium">
          Não informado
        </ng-container>
      </span>
      <span class="info">
        <strong>Data entrega</strong>:
        <ng-container *ngIf="order?.finalDeliveryDate">
          {{ order.finalDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        <ng-container *ngIf="!order?.finalDeliveryDate">
          Não informado
        </ng-container>
      </span>
      <span
        class="info"
        *ngIf="
          order?.pedidoV &&
          edition?.pedidoV &&
          order.pedidoV !== edition.pedidoV
        "
      >
        <strong>{{ shippingOrderType }} entregue com a edição</strong>:
        {{ edition.theme }} ({{ edition.editionId }})
      </span>
      <div class="resend-info" *ngIf="shippingOrderRequest?.ticketId">
        <span class="info">
          <strong>Ticket</strong>:&nbsp;
          <a
            [href]="
              'https://b4asupport.zendesk.com/agent/tickets/' +
              shippingOrderRequest.ticketId
            "
            target="_blank"
            class="data-link"
            style="text-decoration: underline"
            pTooltip="Ver ticket no Zendesk"
            tooltipPosition="bottom"
          >
            {{ shippingOrderRequest.ticketId || 'Não informado' }}
          </a>
        </span>
        <span class="info">
          <strong>Origem do Ticket</strong>:
          {{ shippingOrderRequest.ticketOrigin || 'Não informado' }}
        </span>
        <span class="info full-w">
          {{ shippingOrderRequest.ticketDetail || 'Não informado' }}
        </span>
      </div>
      <div class="shipping-summary">
        <span class="info">
          <strong> Frete </strong>:&nbsp;
          <ng-container *ngIf="shippingOrder.shippingTotal">
            {{ shippingOrder.shippingTotal | currency: 'BRL' }}
          </ng-container>
          <ng-container *ngIf="!shippingOrder.shippingTotal">
            Grátis
          </ng-container>
        </span>
        <span
          class="info info--full"
          *ngIf="
            shippingOrder.shippingStreet &&
            shippingOrder.shippingCity &&
            shippingOrder.shippingState
          "
        >
          <strong>Endereço</strong>:
          <ng-container *ngIf="!updateAddress">
            {{ shippingOrder.shippingRecipientName }}
            {{ shippingOrder.shippingStreet }}
            {{ shippingOrder.shippingStreetNumber
            }}<span *ngIf="shippingOrder.shippingStreetExtension?.length"
              >, {{ shippingOrder.shippingStreetExtension }}</span
            >
            - {{ shippingOrder.shippingNeighborhood }},
            {{ shippingOrder.shippingCity }} -
            {{ shippingOrder.shippingState }}, Brasil, CEP
            {{ shippingOrder.shippingPostalCode }}
          </ng-container>
          <ng-container
            *ngIf="
              permission &&
              addressList?.length > 0 &&
              shippingOrder.shippingOrderTypeId === 2 &&
              [14, 15, 16].includes(shippingOrder.shippingOrderStatus)
            "
          >
            <p-button
              icon="pi pi-pencil"
              styleClass="p-button-xs p-button-primary"
              [text]="true"
              size="small"
              pTooltip="Alterar endereço"
              tooltipPosition="bottom"
              *ngIf="!updateAddress"
              (onClick)="updateShippingAddress()"
            />
            <p-dropdown
              [options]="shippingAddress"
              [(ngModel)]="shippingOrder.shippingInfoId"
              (onBlur)="updateAddress = false"
              (onHide)="updateAddress = false"
              [autoDisplayFirst]="false"
              appendTo="body"
              [filter]="true"
              optionValue="addressId"
              (onChange)="saveAddress()"
              #address
              *ngIf="updateAddress"
            >
              <ng-template pTemplate="item" let-address>
                {{ address.street }}
                {{ address.streetNumber
                }}<span *ngIf="address.streetExtension?.length"
                  >, {{ address.streetExtension }}</span
                >
                - {{ address.neighborhood }}, {{ address.city }} -
                {{ address.state }}, Brasil, CEP
                {{ address.postalCode }}
                <ng-container *ngIf="address.subscriber">
                  - (Endereço da assinatura)</ng-container
                >
              </ng-template>
              <ng-template pTemplate="selectedItem" let-address>
                {{ address.street }}
                {{ address.streetNumber
                }}<span *ngIf="address.streetExtension?.length"
                  >, {{ address.streetExtension }}</span
                >
                - {{ address.neighborhood }}, {{ address.city }} -
                {{ address.state }}, Brasil, CEP
                {{ address.postalCode }}
                <ng-container *ngIf="address.subscriber">
                  - (Endereço da assinatura)</ng-container
                >
              </ng-template>
            </p-dropdown>
          </ng-container>
        </span>
        <span class="info">
          <strong>Transportadora</strong>:
          <ng-container *ngIf="!updateCompany">
            {{ companyServiceName }}
          </ng-container>
          <p-button
            icon="pi pi-pencil"
            styleClass="p-button-xs p-button-primary"
            [text]="true"
            size="small"
            [pTooltip]="
              companyServiceId
                ? 'Alterar transportadora'
                : 'Selecionar transportadora'
            "
            tooltipPosition="bottom"
            *ngIf="
              canUpdateShippingCompany &&
              shippingCompaniesAvailable?.length > 0 &&
              !updateCompany
            "
            (onClick)="updateShippingCompany()"
          />
          <p-dropdown
            [options]="shippingCompaniesAvailable"
            [(ngModel)]="companyServiceId"
            (onBlur)="updateCompany = false"
            (onHide)="updateCompany = false"
            [autoDisplayFirst]="false"
            appendTo="body"
            [filter]="true"
            #companies
            (onChange)="saveShippingCompany()"
            *ngIf="canUpdateShippingCompany && updateCompany"
          />
        </span>
      </div>
      <div class="payment-summary">
        <span *ngIf="payment">
          <h3>Pagamento</h3>
          <p>
            <strong>TID</strong>:
            <a [href]="gatewayLink" class="data-link" target="_blank">
              {{ payment.tid }}
            </a>
          </p>
          <p><strong>Gateway</strong>: {{ payment.gatewayName }}</p>
          <p>
            <strong>Status pagamento</strong>:&nbsp;
            <span class="status" [ngClass]="paymentStatusClass">
              {{ payment.transactionStatusName | titlecase }}
            </span>
          </p>
          <p *ngIf="gatewayPayment">
            <strong>Status gateway</strong>:&nbsp;
            <span class="status" [ngClass]="gatewayPaymentStatusClass">
              {{ gatewayPayment.status | titlecase }}
            </span>
          </p>
          <p><strong>Valor</strong>: {{ payment.amount | currency: 'BRL' }}</p>
          <p *ngIf="creditCard">
            <app-credit-card-view [creditCard]="creditCard" />
          </p>
        </span>
        <span class="payment-summary__summary">
          <h3>Resumo</h3>
          <p *ngIf="shippingOrder.shippingOrderTypeId === 3">
            <strong>Glampoints:</strong>
            <span>{{ shippingOrder.orderPointsTotal | number: '1.0-2' }}</span>
          </p>
          <p *ngIf="shippingOrder.shippingTotal">
            <strong>Entrega:</strong>
            <span>{{ shippingOrder.shippingTotal | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="!shippingOrder.shippingTotal">
            <strong>Entrega:</strong><span>Grátis</span>
          </p>
          <p *ngIf="shippingOrder.orderTotal">
            <strong>Total:</strong>
            <span>{{ shippingOrder.orderTotal | currency: 'BRL' }}</span>
          </p>
        </span>
      </div>
      <div class="buttons">
        <p-button
          *ngIf="permission && canRefundOrder"
          label="Estornar pedido"
          styleClass="p-button-help"
          icon="pi pi-times-circle"
          (onClick)="refundOrder()"
        />
        <p-button
          *ngIf="
            permission &&
            shippingOrder.shippingOrderTypeId === 3 &&
            rewards?.length > 0 &&
            refunds?.length < items?.length
          "
          label="Estornar produto"
          styleClass="p-button-warning"
          icon="pi pi-undo"
          (onClick)="refundProduct()"
        />
        <p-button
          label="Aprovar pedido"
          styleClass="p-button-success"
          icon="pi pi-check"
          (onClick)="approveOrder()"
          *ngIf="
            shippingOrder?.shippingOrderStatus === 14 ||
            shippingOrder?.shippingOrderStatus === 16
          "
        />
        <p-button
          label="Reprovar pedido"
          styleClass="p-button-danger"
          icon="pi pi-times"
          (onClick)="rejectOrder()"
          *ngIf="
            shippingOrder?.shippingOrderStatus === 14 ||
            shippingOrder?.shippingOrderStatus === 15 ||
            shippingOrder?.shippingOrderStatus === 16
          "
        />
        <p-button
          label="Recalcular estoque"
          styleClass="p-button-warning"
          icon="pi pi-refresh"
          (onClick)="recalculateStocks()"
          pTooltip="Utilize este botão caso não tenha produtos com problema de estoque no pedido"
          *ngIf="availableStock"
        />
      </div>
    </div>
    <div class="card">
      <p-tabView
        [activeIndex]="tabIndex"
        (activeIndexChange)="navigate($event)"
      >
        <p-tabPanel
          header="Produtos {{
            items?.length > 0
              ? '(' + (items.length | number: '1.0-0') + ')'
              : ''
          }}"
        >
          <app-table
            [lazy]="false"
            [cols]="productCols"
            modelName="produtos"
            [elements]="items"
            sortField="productVariantName"
            [sortOrder]="-1"
            [addButton]="pendingResend"
            addLabel="Produto"
            [addButtonAction]="true"
            tableTitle=" "
            [rowBackground]="rowBackground"
            [actionButtons]="actionButtons"
            [defaultRows]="20"
            (addButtonClick)="productSelectionModal()"
            *ngIf="items"
          />
        </p-tabPanel>
        <p-tabPanel
          *ngIf="extraItems?.length"
          header="Produtos extras ({{ extraItems.length | number: '1.0-0' }})"
        >
          <app-table
            [lazy]="false"
            [cols]="extraItemsCols"
            modelName="produtos"
            [elements]="extraItems"
            sortField="productVariantName"
            [sortOrder]="-1"
            [addButton]="false"
            tableTitle=" "
            *ngIf="items"
          />
        </p-tabPanel>
        <p-tabPanel
          header="Estornos {{ '(' + (refunds.length | number: '1.0-0') + ')' }}"
          *ngIf="refunds?.length > 0"
        >
          <app-table
            [lazy]="false"
            [cols]="refundCols"
            modelName="produtos"
            [elements]="refunds"
            sortField="productVariantName"
            [sortOrder]="-1"
            [addButton]="false"
            tableTitle=" "
          />
        </p-tabPanel>
        <p-tabPanel
          header="Mudanças transportadora {{
            '(' + (companyLogs.length | number: '1.0-0') + ')'
          }}"
          *ngIf="companyLogs?.length > 0"
        >
          <app-table
            [lazy]="false"
            [cols]="companyLogsCols"
            modelName="alterações"
            [elements]="companyLogs"
            sortField="logDate"
            [sortOrder]="-1"
            [addButton]="false"
            tableTitle=" "
          />
        </p-tabPanel>
        <p-tabPanel
          header="Mudanças de endereço {{
            '(' + (addressChanges.length | number: '1.0-0') + ')'
          }}"
          *ngIf="addressChanges?.length > 0"
        >
          <app-table
            [lazy]="false"
            [cols]="colsAddressChanges"
            modelName="alterações"
            [elements]="addressChanges"
            sortField="dateCreated"
            [sortOrder]="1"
            [addButton]="false"
            tableTitle=" "
          />
        </p-tabPanel>
        <p-tabPanel
          *ngIf="itemLogs?.length"
          header="Alterações de produtos ({{
            itemLogs.length | number: '1.0-0'
          }})"
        >
          <app-table
            [lazy]="false"
            [cols]="itemLogCols"
            modelName="alterações"
            [elements]="itemLogs"
            sortField="dateCreated"
            [sortOrder]="-1"
            [addButton]="false"
            tableTitle=" "
          />
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<p-toast />
<p-confirmDialog />
